<template>
  <div id="container" v-loading="loading">
    <!-- <div @click="isOK=false">竞拍失败</div>
    <div @click="isOK=true">竞拍成功</div> -->
    <h1 class="full_layout terms_title">{{$t('base.bidHistory')}}</h1>
    <div class="full_layout bid_history_box" v-if="list">
      <!--  <span class="el-icon-warning text_red span_alert" v-if="CountDown(list.time)=='00:00'">You have to bid at least US $ 17.00</span> -->
      <span class="el-icon-success text_greed span_alert" v-if="CountDown(list.EffectiveTime)=='00:00'&&isOK">{{userInfo.NickName}}{{$t('symbol.winner')}}</span>
      <span class="el-icon-warning text_red span_alert" v-if="list.EffectiveTimeStr!='Ended listing'&&!isOK&&bidList.length>0&&bidnum>0">{{$t('symbol.outbidYou')}}</span>
      <span class="el-icon-success text_greed span_alert" v-if="list.EffectiveTimeStr!='Ended listing'&&isOK">{{$t('alert.highestBidEnd')}}</span>
      <div class="contact_box like_box" v-if="list">
        <el-image class="like_img" :src="list.TitImg" fit="contain"></el-image>
        <div class="like_detail">
          <p>{{list.Title}}</p>
        </div>
      </div>
      <div class="contact_box">
        <div class="bid_history_info info_list"><span class="text_gray">{{list.Status != -2?$t('colon.CurrentBid'):$t('colon.winBid')}}</span><div class="text_blue">{{areaSymbol}} <em>{{list.USD_Price}}</em></div></div>
        <div class="bid_history_info info_list" v-if="domesticCustom">
          <span class="text_gray">{{$t('colon.shippFee')}}</span>
          {{domesticCustomText}}
          <!-- {{domesticCustom.Status==1?$t('base.freeShipping'):''}}
          {{domesticCustom.Status==2?$t('base.payOnDelivery'):''}}
          {{domesticCustom.Status==3?'$ '+domesticCustom.USD_Price:''}} -->
        </div>
        <div class="bid_history_info info_list"><span class="text_gray">{{$t('colon.itemNumber')}}</span>{{list.Code}}</div>
        <div class="bid_history_info_box">
          <div class="bid_history_info"><span class="text_gray">{{$t('colon.bid')}}&nbsp;</span>{{list.AuctionCount}}</div>
          <div class="bid_history_info"><span class="text_gray">{{$t('colon.bidders')}}&nbsp;</span>{{list.AuctionsUserCount}}</div>
          <div class="bid_history_info"><span class="text_gray">{{$t('colon.timeLeft')}}&nbsp;</span><span :class="getDown(list.EffectiveTime)==1?'text_red':''">{{CountDown(list.EffectiveTime)}}</span></div>
          <div class="bid_history_info"><span class="text_gray">{{$t('colon.duration')}}&nbsp;</span>{{list.EffectiveDay}} {{list.EffectiveDay != 1 ?$t('base.days'):$t('base.day')}}</div>
          <div class="bid_history_info"><span class="text_gray">{{$t('colon.timeEnd')}}&nbsp;</span>{{list.EffectiveTime|setTime}}</div>

          <!-- {{progress.SRStatus ==2?'Completed':'Rescinded'}} -->
        </div>
        <el-button type="primary" @click="getAuctionCheck()" v-if="list.EffectiveTimeStr!='Ended listing'&&userInfo.MappingUserId!=list.SellUserID&&userInfo.Count>0">{{$t('base.placeBid')}}</el-button>
        <el-button type="primary" @click="isAddCout()" v-if="list.EffectiveTimeStr!='Ended listing'&&userInfo.MappingUserId!=list.SellUserID&&userInfo.Count<=0">{{$t('base.placeBid')}}</el-button>
        <!-- <el-button type="primary" v-if="isOK!=null">Bid Again</el-button> -->
      </div>
      <div class="bid_list_box">
        <!-- <div class="contact_box">
          <router-link class="text_blue" :to="{path:'/mycardhoddy/bids'}" v-if="isOK!=null">Learn more about bidding</router-link>
        </div> -->
        <div class="bid_list table_th_gray">
          <div>{{$t('base.bidder')}}</div>
          <div>{{$t('base.bidAmount')}}</div>
          <div>{{$t('base.bidTime')}}</div>
        </div>
        <div class="bid_list" v-for="(item,index) in bidList" :key="index" v-if="bidList.length>0" :class="[index>0?'text_gray':'',item.IsAuto?'em':'']" @change="getDetail">
          <div><span :class="[(CountDown(list.EffectiveTime)=='00:00'&&isOK && index==0?'text_greed':'')]">{{item.CreateUserName}} ({{item.BuyFavorableCount}})</span><span v-if="item.MemberSource != userInfo.MemberSource" class="earth" :class="item.MemberSource"></span></div>
          <div :class="[(CountDown(list.EffectiveTime)=='00:00' && index==0&&bidnum>0&&!isOK ?'text_red':''),(list.EffectiveTimeStr!='Ended listing'&&isOK && index==0 ?'text_greed':''),(list.EffectiveTimeStr!='Ended listing'&&!isOK&&bidList.length>0&&bidnum>0 && index==0?'text_red':'')]">{{areaSymbol}} {{item.USD_Price}}</div>
          <div>{{item.CreateDate|setTime}}</div>
        </div>
      </div>
      <p class="text_gray" style="word-break: break-word;">{{$t('alert.bidSituation')}}</p>
    </div>
    <place-bid v-if="userInfo!=null&&list!=null" :Visible="dialogVisible" @getDialog="getDialog" :Auction='isAuction' :list="list" :time="list.EffectiveTime" />
  </div>
</template>
<script>
import bus from '@/api/bus';
import { countDown, setUTC, getInfo, priceExchange, CensoredName, getTime,isUserDomest } from "@/api/public";
import PlaceBid from "@/components/dialog/placebid";
export default {
  name: 'tabslist',
  components: { PlaceBid },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      domesticCustom:null,
      domesticCustomText:'',
      loading: false,
      cid: '',
      userInfo: null,
      isOK: false,
      nowData: new Date().getTime(),
      dialogVisible: false,
      list: null,
      bidList: [],
      isAuction: false,
      isread: true,
      priceBid: '',
      bidnum:0
    }
  },
  filters: {
    setExchange(val) {
      return priceExchange(val, 'USD')
    },
    // setName(val) {
    //   return CensoredName(val)
    // },
    setTime(val) {
      val = val.toString().replace(/-/g, "/")
      return getTime(val, -8,'','cn')
    }
  },
  created() {
    bus.$emit('headerTitle', this.$t('base.myCardHobby'));
    this.cid = this.$route.params.id
    this.userInfo = getInfo()
    this.getDetail()
    this.cardTimer();
  },
  mounted() {},
  methods: {
    //竞拍资格校验
    getAuctionCheck() {
      let that = this
      let data = { 'operator_id': this.userInfo.MappingUserId, 'memberid': this.userInfo.MappingUserId, 'token': this.userInfo.ChineseToken, 'CommodityID': this.list.ID }
      this.$get(this.$interface.AuctionCheck, data).then(res => {
        that.isread = false;
        if (res.result == 1) {
          that.isAuction = true;
          that.dialogVisible = true;
        } else {
          that.list.DepositNum = res.data.DepositNum;
          that.list.SumMoney = res.data.SumMoney;
          that.isAuction = false;
          that.dialogVisible = true;
        }
        //this.getPrice()
        // msg: '竞拍校验通过', result: 1
      })
    },
    // 判断默认地址是否为空
    isAddCout() {
      let that=this
      this.$confirm(that.$t('alert.noAddress'), that.$t('base.somethingImportant'), {
        confirmButtonText: that.$t('base.goToSet'),
        cancelButtonText: that.$t('base.cancel'),
        lockScroll: false
      }).then(() => {
        let url = this.$router.resolve({ path: '/mycardhobby/setting' })
        window.open(url.href, '_blank');
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });          
      });
    },
    // 获取最新价格
    getPrice() {
      let that = this
      let data = { 'operator_id': this.userInfo.MappingUserId, 'memberid': this.userInfo.MappingUserId, 'token': this.userInfo.ChineseToken, 'CommodityID': this.list.ID }
      this.$get(this.$interface.AuctionIndex, data).then(res => {
        if (res.result != 0) {
          that.priceBid = res.data
        }
      })
    },
    // 获取商品详情
    getDetail() {
      //this.loading=true
      let that = this;
      let data = { 'memberid': '', 'CommodityID': this.cid }
      console.log(1111,that.userInfo.NickName)
      if (that.userInfo != null) {
        data = { 'memberid': that.userInfo.MappingUserId, 'token': that.userInfo.ChineseToken, 'operator_id': that.userInfo.MappingUserId, 'CommodityID': this.cid }
      }
      that.$get(that.$interface.DetailCommodity, data).then(res => {
        if (res.result != 0) {
          let result = res.data
          let num=0;
          result.HighestPrice = priceExchange(result.HighestPrice, 'USD')
          that.list = result;
          that.bidList = result.Auctions;
          var domesticCustom=isUserDomest(that.userInfo,result.DomesticCustom,result.MemberSource)
          //判断是否是最高出价或者已经胜利的
          if (result.Auctions[0].CreateUserName == that.userInfo.NickName) {
            that.isOK = true
          }else{
            
            result.Auctions.map(r=>{
              if(r.CreateUserName==that.userInfo.NickName){
                num++;
              }
            })
            that.bidnum=num
          }
          that.domesticCustom=domesticCustom
          if(domesticCustom.Status==1){
            that.domesticCustomText=that.$t('base.freeShipping')
          }else if(domesticCustom.Status==2){
            that.domesticCustomText=result.MemberSource!='US'?that.$t('alert.PaidOnDelivery'):that.$t('base.payOnDelivery')
          }else if(domesticCustom.Status==3){
             that.domesticCustomText= that.areaSymbol+' '+domesticCustom.USD_Price
          }
          that.loading = false
        } else {}
        that.loading = false
      })
    },
    getDialog(val, val1) {
      this.dialogVisible = val;
        this.getDetail()
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    // 判断是否小于等于1分钟
    getDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      //console.log(itemEnd)
      let val = setUTC(itemEnd, -8,'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval, 0)
    },
    //
    CountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      //console.log(itemEnd)
      let val = setUTC(itemEnd, -8,'cn')
      let newval = setUTC(this.nowData, -8)
      //console.log(val,newval)
      return countDown(val, newval)
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/terms.css";
.earth{
  margin-left: 10px;
	padding: 0 16px 0 0;
	background: url(/static/images/icon/icon_earth.svg) no-repeat 100% 50%;
}
.bid_history_box {
  margin-bottom: 24px;
}

.contact_box {
  /* width: 544px; */
  margin-bottom: 24px;
}

.like_box {
  display: flex;
}

.like_box .like_img {
  width: 88px;
  height: 88px;
  background-color: #e0e0e0;
  border-radius: 6px;
  margin-right: 12px;
}

.like_detail {
  width: 544px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* width: 80%; */
  font-size: 16px;
}

.bid_list_box {
  border-top: 1px solid #e0e0e0;
  padding-top: 24px;
  margin-bottom: 16px;
}

.bid_list {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  height: 48px;
  align-items: center;
}

.bid_list>div {
  width: 33%;
  padding: 0 12px;
}
.bid_list.em>div{
  font-style: italic;
  /* color: #a0a0a0; */
}

.span_alert {
  padding: 16px;
  border: 1px solid #e0e0e0;
  background-color: #f7f7f7;
  border-radius: 4px;
  min-width: 300px;
  display: inline-block;
  margin-bottom: 20px;
}

.span_alert.el-icon-warning {
  border-color: #F9D2D2;
  background-color: #FDF4F4;
}

.bid_history_info {
  display: flex;
  margin-bottom: 24px;
  align-items: flex-end;
  font-size: 16px;
}

.bid_history_info>span {
  width: 20%;
}
.bid_history_info>div{
    display: flex;
    align-items: flex-end;
}
.bid_history_info>div>em {
  font-size: 24px;
  line-height: 0.9;
  font-weight: bold;
  margin-left: 2px;
}
.bid_history_info.info_list{
  width: 50%;
}
.bid_history_info_box {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.bid_history_info_box .bid_history_info>span {
  width: auto;
}
.el-button{
  padding: 11px 20px;
  line-height: 16px;
}
.el-icon-success{
  background: rgba(239, 247, 230, 1);
  border: 1px solid rgba(222, 238, 204, 1);
}
</style>



// WEBPACK FOOTER //
// src/pages/user/bidhistory.vue